import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provedor } from "./estado.jsx";
import Rotas from "./rotas.jsx";
import { Dicas } from "@/componentes/Dica.tsx";
import { Perguntas } from "@/componentes/pergunta.tsx";
/* O erro da tela vai para o painel de observabilidade. Importado primeiro que o
   render: erro na montagem também tem de chegar. */
import { ouvintesDoReact } from "./telemetria-tela.js";
/* A folha da mesa: Tailwind e os tokens do shadcn com a paleta da casa. Vem
   ANTES do resto — é a base sobre a qual as outras duas folhas escrevem. */
import "./index.css";
/* O que não cabe em classe: alvo de dedo, menos movimento e o atalho de pular
   para o campo de mensagem. */
import "./acesso.css";

/* Pedaço da tela que sumiu do servidor (versão nova no ar, aba de antes): o
   Vite avisa aqui, e recarregar pega o `index` novo. Uma vez por minuto no
   máximo — se o 404 for de verdade, recarregar em laço seria pior que o erro. */
window.addEventListener("vite:preloadError", (ev) => {
  try {
    const antes = Number(sessionStorage.getItem("recarregou-versao") ?? 0);
    if (Date.now() - antes < 60_000) return;
    sessionStorage.setItem("recarregou-versao", String(Date.now()));
  } catch {
    /* sem sessionStorage: recarrega assim mesmo, é um toque só */
  }
  ev.preventDefault();
  location.reload();
});

createRoot(document.getElementById("app"), ouvintesDoReact).render(
  <StrictMode>
    <BrowserRouter>
      <Provedor>
        <Rotas />
        {/* Uma dica e uma caixa de pergunta para a tela inteira — inclusive a de
            entrada. As duas são chamadas de qualquer lugar e não podem existir
            em duplicata. */}
        <Dicas />
        <Perguntas />
      </Provedor>
    </BrowserRouter>
  </StrictMode>,
);
